/* @flow */

import React from 'react';

import { pluralize } from 'constants/plural';

const Showing = ({ total, offset, size, entity }) => {
  const start = total ? +offset + 1 : 0;
  const end = Math.min(
    +offset + +size,
    total,
  );

  return (
    <div spacing="0.5rem" className="test-showing">
      <span>Showing </span>
      <strong>{start.toLocaleString()}</strong>
      <span> - </span>
      <strong>{end.toLocaleString()}</strong>
      <span> of </span>
      <strong>{total.toLocaleString()}</strong>
      <span> {pluralize(entity).toLowerCase()}</span>
    </div>
  );
};

export default Showing;
